export const SUCCESS = 'SUCCESS';
export const SYNCING = 'SYNCING';
